<div class="container">
  <div class="row justify-content-center">
    <div class="col">
      <div
        class="rating-bar d-flex justify-content-center fs-{{ size }}"
        [ngClass]="{ readonly: readonly }"
      >
        @for (_ of range; track _; let i = $index) {
          <span class="px-2" (click)="rate(i)">
            @if (!hasHalfStar(i)) {
              <i
                class="fs-18"
                [ngClass]="{
                  'bi-star-fill': hasFullStar(i),
                  'bi-star': hasEmptyStar(i)
                }"
              ></i>
            }
            @if (hasHalfStar(i)) {
              <i class="bi bi-star-half fs-18"></i>
            }
          </span>
        }
      </div>
    </div>
  </div>
</div>
